(function() {
    'use strict';

    angular
        .module('app.areas')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/areas',
                config: {
                    templateUrl: 'app/areas/areas.html',
                    controller: 'Areas',
                    controllerAs: 'vm',
                    title: 'areas'
                }
            },
            {
                url: '/editar-area/:id?',
                config: {
                    templateUrl: 'app/areas/editarArea.html',
                    controller: 'EditarArea',
                    controllerAs: 'vm',
                    title: 'EditarArea'
                }
            }
        ];
    }
})();
